import ReactImageUploading, { ImageListType } from "react-images-uploading";

const ImageUpload = ({
  image,
  onImageUpload,
  onRemoveImage,
}: {
  image: string;
  onImageUpload: (base64: string) => void;
  onRemoveImage: () => void;
}) => {
  const handleImageUpload = (v: ImageListType) => {
    onImageUpload(v[0]?.dataURL || "");
  };

  return (
    <ReactImageUploading
      value={[{ dataURL: image }]}
      onChange={handleImageUpload}
    >
      {({ imageList, onImageUpload }) => (
        // write your building UI
        <div className="upload__image-wrapper">
          {!image && <button onClick={onImageUpload}>Bild hochladen</button>}
          {imageList.map((image, index) => (
            <div key={index}>
              <img src={image.dataURL} alt="" width="100" />
              <button onClick={() => onRemoveImage()}>Bild entfernen</button>
            </div>
          ))}
        </div>
      )}
    </ReactImageUploading>
  );
};

export default ImageUpload;
